// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2mNZ0","notes":"Notes_notes__FToT2"};